module.exports = __webpack_public_path__ + "static/media/basketball-ground.53eefca9.png";